import superagent from 'superagent';

type ExtendedRequest = superagent.Request & {
  callback: SuperAgentCallback;
};

type InterceptorCallback = (
  error: superagent.ResponseError,
  response: superagent.Response
) => Promise<boolean>;

type SuperAgentCallback = (error: superagent.ResponseError, response: superagent.Response) => void;

const createInterceptor = (callback: InterceptorCallback) => {
  return (request: superagent.Request) => {
    const originalCallback = (request as ExtendedRequest).callback;

    // eslint-disable-next-line no-param-reassign
    (request as ExtendedRequest).callback = async (
      error: superagent.ResponseError,
      response: superagent.Response
    ) => {
      const isOriginalCallNeeded = await callback.call(request, error, response);

      if (isOriginalCallNeeded) {
        originalCallback.call(request, error, response);
      }
    };
  };
};

export default createInterceptor;
